import { useState } from 'react'
import { type IntlShape, useIntl } from 'react-intl'
import { components, type OptionProps } from 'react-select'

import type { SelectOption } from 'Components/Select/Select.types'

import { getFullContactName } from 'Utilities'

import type { PortalReturnLabelSelectableReturnCase } from './PortalReturnLabelModal.types'

export interface PortalReturnLabelDeviceOptionData extends SelectOption {
  returnCase: PortalReturnLabelSelectableReturnCase
}

export const buildDeviceOptionLabel = (
  rc: PortalReturnLabelSelectableReturnCase,
  intl?: IntlShape,
): string => {
  const name = rc.stocklistItem?.deviceDefinition?.name ?? ''
  const identifier =
    rc.stocklistItem?.imei || rc.stocklistItem?.serialNumber || ''
  const employeeName = rc.employee?.contact
    ? getFullContactName(rc.employee.contact, {
        intl,
        showDefaultText: false,
      })
    : ''

  return [name, identifier, employeeName].filter(Boolean).join(' . ')
}

export const PortalReturnLabelDeviceOption = (
  props: OptionProps<PortalReturnLabelDeviceOptionData, false>,
) => {
  const { data } = props
  const { returnCase } = data
  const intl = useIntl()
  const [hasImageError, setHasImageError] = useState(false)
  const device = returnCase.stocklistItem?.deviceDefinition
  const employeeName = returnCase.employee?.contact
    ? getFullContactName(returnCase.employee.contact, {
        intl,
        showDefaultText: false,
      })
    : ''
  const detailParts = [
    returnCase.stocklistItem?.imei,
    returnCase.stocklistItem?.serialNumber,
    employeeName,
  ].filter(Boolean)
  const imageURL = hasImageError ? null : (device?.imageURL ?? null)

  return (
    <components.Option {...props}>
      <div className="PortalReturnLabelModal-deviceOption">
        {imageURL && (
          <img
            alt=""
            className="PortalReturnLabelModal-deviceOption-img"
            onError={() => setHasImageError(true)}
            src={imageURL}
          />
        )}
        <div className="PortalReturnLabelModal-deviceOption-meta">
          <div className="PortalReturnLabelModal-deviceOption-name">
            {device?.name}
          </div>
          {detailParts.length > 0 && (
            <div className="PortalReturnLabelModal-deviceOption-detail small text-muted">
              {detailParts.join(' . ')}
            </div>
          )}
        </div>
      </div>
    </components.Option>
  )
}
